import { createYouTubeVideos } from "./video.youtube";

document.addEventListener("DOMContentLoaded", () => {
    const hubSection = document.querySelector(".hub-cards");
    if (!hubSection) return false;

    const showBtn = document.querySelector(".hub-cards__show-more");
    const cards = document.querySelectorAll(".card");
    const hiddenCards = [...document.querySelectorAll(".card--hidden")];
    const catList = document.querySelectorAll(".hub-cards .custom-option");
    const cardPlayBtns = document.querySelectorAll(".js-play-btn");

    showBtn.addEventListener("click", showMoreCards);
    catList.forEach((item) => item.addEventListener("click", filterCards));

    function setMediaSrc(cardArr) {
        cardArr.forEach((card) => {
            const videoEl = card.querySelector(".card__video");
            const imageEl = card.querySelector(".card__img");
            const imgSrc = imageEl.dataset.source;
            const vidSrc = videoEl.dataset.source;

            imgSrc && (imageEl.src = imgSrc);
            vidSrc && (videoEl.dataset.vidId = vidSrc);
        });
    }

    function getVideoCards(cardsArr) {
        return cardsArr.filter((card) => card.querySelector(".card__video").dataset.source).map((card) => card.querySelector(".card__video"));
    }

    function displayCard(card) {
        card.classList.remove("card--hidden");
    }

    function showMoreCards() {
        let i = 0;
        const nextCardSet = hiddenCards.filter((card) => {
            if (i < 3 && card.classList.contains("card--hidden")) {
                i++;
                return card;
            }
        });

        setMediaSrc(nextCardSet);

        const nextVideoSet = getVideoCards(nextCardSet);
        createYouTubeVideos(nextVideoSet);

        nextCardSet.forEach((card) => displayCard(card));

        const hasHiddenCards = hiddenCards.some((card) => card.classList.contains("card--hidden"));
        !hasHiddenCards && showBtn.classList.add("hub-cards__show-more--hidden");
    }

    function filterCards() {
        const selectedCat = this.dataset.value;
        const selectedCards = selectedCat == "all" ? [...cards] : [...cards].filter((card) => card.dataset.categories.includes(selectedCat));
        const videoCards = getVideoCards(selectedCards);

        setMediaSrc(selectedCards);
        createYouTubeVideos(videoCards);

        cards.forEach((card) => {
            selectedCat == "all" || card.dataset.categories.includes(selectedCat) ? displayCard(card) : card.classList.add("card--hidden");
        });

        const cardsContainer = document.querySelector(".hub-cards__list");
        const cardsContainerPosition = cardsContainer.getBoundingClientRect().top + window.scrollY - 180;
        window.scrollTo(0, cardsContainerPosition);

        document.querySelectorAll("details").forEach((detail) => detail.removeAttribute("open"));
        showBtn.classList.add("hub-cards__show-more--hidden");
    }

    cardPlayBtns.forEach((btn) => {
        btn.addEventListener("click", () => {
            const card = btn.closest(".card");
            const cardVideo = card.querySelector(".card__video");
            const observer = new MutationObserver((events) => {
                events.forEach((event) => {
                    !event.target.classList.contains("playing") && card.classList.remove("video-playing");
                });
            });

            card.classList.add("video-playing");
            observer.observe(cardVideo, { attributeFilter: ["class"] });
        });
    });
});
